/** @format */
import React, { FunctionComponent, useEffect } from 'react';

type EmbeddedScriptProps = {
    id: string;
    src: string;
    attributes?: Record<string, string>;
    'data-testid'?: string;
};

export const EmbeddedScript: FunctionComponent<EmbeddedScriptProps> = ({
    id,
    src,
    attributes = {},
    'data-testid': dataTestId = 'embedded-script',
}) => {
    useEffect(() => {
        const script = document.createElement('script');

        script.src = src;

        Object.entries(attributes).forEach(([key, value]) => {
            script.setAttribute(key, value);
        });
        script.setAttribute('data-testid', dataTestId);

        document.getElementById(id)?.appendChild(script);

        return () => {
            document.getElementById(id)?.removeChild(script);
        };
    }, [id, src, attributes, dataTestId]);

    return <div id={id}></div>;
};
